import { useEffect, useRef } from 'react';
import { useAnalyticsReportingShallowStore } from '../hooks/use-analytics-reporting-store';
import { triggerFileDownload } from '../utils/downloader';

export const DownloadTrigger = () => {
  const { downloadStatus } = useAnalyticsReportingShallowStore('downloadStatus');
  const wasPreparing = useRef(downloadStatus?.isPreparingDownload || false);

  useEffect(() => {
    const isPreparing = downloadStatus?.isPreparingDownload || false;
    const downloadUrl = downloadStatus?.downloadUrl;
    const fileName = downloadStatus?.fileName;
    const justCompleted = wasPreparing.current === true && isPreparing === false && !!downloadUrl;

    if (justCompleted) {
      triggerFileDownload(downloadUrl, fileName);
    }

    wasPreparing.current = isPreparing;
  }, [downloadStatus]);

  return null;
};
